import axios from 'axios';
import { API_BASE } from '../utils/apiBase';
import api from './api';

const API_URL = API_BASE;

// Raw axios (no auth) for public endpoints
const publicApi = axios.create({
  baseURL: API_URL,
});

const ticketService = {
  createGuestCheckout: async (eventId, { name, email, quantity = 1, promoCode = null, ticketTierId = null }) => {
    const response = await publicApi.post(`/events/${eventId}/guest-checkout`, {
      name,
      email,
      quantity,
      promoCode,
      ticketTierId,
    });
    return response.data;
  },

  joinGuestWaitlist: async (eventId, { name, email, quantity = 1 }) => {
    const response = await publicApi.post(`/events/${eventId}/guest-waitlist`, { name, email, quantity });
    return response.data;
  },

  // Free-event RSVP: issues a ticket with no account and no payment. Returns
  // { ticketUrl, ticketCode } — the same ticket is also emailed to the guest.
  createGuestFreeTicket: async (eventId, { name, email, quantity = 1 }) => {
    const response = await publicApi.post(`/events/${eventId}/guest-free-ticket`, { name, email, quantity });
    return response.data;
  },

  getTicket: async (ticketCode) => {
    const response = await publicApi.get(`/tickets/${ticketCode}`);
    return response.data;
  },

  verifyTicket: async (ticketCode) => {
    const response = await api.post(`/tickets/${ticketCode}/verify`);
    return response.data;
  },

  resendTicket: async (ticketCode) => {
    const response = await api.post(`/tickets/${ticketCode}/resend`);
    return response.data;
  },

  // New multi-ticket endpoints
  getMyTickets: async () => {
    const response = await api.get('/tickets/me');
    return response.data;
  },

  getTicketsForApplication: async (applicationId) => {
    const response = await api.get(`/tickets/application/${applicationId}`);
    return response.data;
  },

  sendTicket: async (ticketId, { email, recipientName }) => {
    const response = await api.post(`/tickets/${ticketId}/send`, { email, recipientName });
    return response.data;
  },

  // ── Transfers ──
  // Handing a seat to someone else. No money moves through Portal; if the
  // ticket was sold, that was settled somewhere else. Calling this twice on the
  // same ticket returns the same link rather than a second one.
  createTransfer: async (ticketId, { email = null, recipientName = null } = {}) => {
    const response = await api.post(`/tickets/${ticketId}/transfer`, { email, recipientName });
    return response.data;
  },

  cancelTransfer: async (transferId) => {
    const response = await api.post(`/tickets/transfers/${transferId}/cancel`);
    return response.data;
  },

  // Public: what the claim page shows before you've signed in. Carries no
  // ticket code and no QR — you don't hold the seat until you claim it.
  getTransferPreview: async (token) => {
    const response = await api.get(`/tickets/transfers/${token}`);
    return response.data;
  },

  claimTransfer: async (token) => {
    const response = await api.post(`/tickets/transfers/${token}/claim`);
    return response.data;
  },
};

export default ticketService;
